  <form name="latestUpdateForm" novalidate [formGroup]="latestUpdateForm" id="latest-update-form" (ngSubmit)="onLatestUpdateSave()" #latestForm="ngForm">
      <div class="modal fade" bsModal tabindex="-1" role="dialog" aria-labelledby="LatestUpdate" aria-hidden="true" #latestUpdateModal="bs-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-primary text-white">
                    <p class="modal-title h3">
                        <strong>Approve & publish</strong>
                    </p>
                    <button type="button" class="btn btn-sm btn-primary" aria-label="Close" (click)="closeModal()">
                      <span aria-hidden="true"><i class="fa fa-close"></i></span>
                    </button>
                </div>
                <div class="modal-body modal-border" *ngIf="allowCorrections">
                     <p class="mb-3">
                        <label class="mb-0 text-info">
                            <strong>Do you want these changes to be visible to clients in the Tax Technical Archive</strong>
                        </label>
                    </p>
                   <div class="d-flex align-items-center mb-2">
                        <input class="mr-2" formControlName="isCorrection" name="isCorrection" type="radio" value="false" id="isCorrection1">
                        <label class="mb-0" for="isCorrection1">
                            <strong>Yes</strong> <span class="text-muted"> - this is a major content update</span>
                        </label>
                   </div>
                   <div class="d-flex align-items-center mb-2">
                        <input class="mr-2" formControlName="isCorrection" name="isCorrection" type="radio" value="true" id="isCorrection2">
                        <label class="mb-0" for="isCorrection2">
                            <strong>No</strong> <span class="text-muted"> - this is a correction</span>
                        </label>
                   </div>
                </div>
                <div class="modal-body modal-border modal-body-expand">
                        <p class="mb-3">
                            <label class="mb-0 text-info">
                                <strong>Do you want these changes to appear in the latest updates section?</strong>
                            </label>
                        </p>
                         <div class="d-flex align-items-center mb-3">
                             <input class="mr-2" formControlName="latestUpdateAlert" name="latestUpdateAlert" type="checkbox" id="latestUpdateAlert">
                             <label class="mb-0" for="latestUpdateAlert">
                                <strong>Yes</strong> - add to latest updates
                             </label>
                        </div>
                        <div class="row mt-3" *ngIf="showLatestUpdateContent">
                            <div class="col">
                                <small class="d-block mb-3 ml-2">The information you enter below will appear on the Homepage screen</small>
                                <div class="form-group" [ngClass]="{ 'has-error': !latestUpdateForm.controls['latestUpdateContent'].valid && latestUpdateForm.controls['latestUpdateContent'].touched }">
                                    <ckeditor *ngIf="loaded"
                                              [editor]="Editor"
                                              formControlName="latestUpdateContent"
                                              [config]="config"
                                              [ckEditorEnhanced]="Editor">
                                    </ckeditor>
                                    <div *ngIf="latestUpdateForm.controls['latestUpdateContent'].hasError('required') && latestUpdateForm.controls['latestUpdateContent'].touched" class="alert alert-danger mt-2">Content to publish is required.</div>
                                    <div *ngIf="latestUpdateForm.controls['latestUpdateContent'].hasError('minlength') && latestUpdateForm.controls['latestUpdateContent'].touched" class="alert alert-danger mt-2">Content to publish needs to be at least 3 characters.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body modal-border" *ngIf="showEmailAlert">
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    <label class="mb-0 text-info">Do you want to notify client users by email?</label>
                                </p>
                                <div class="d-flex align-items-center mb-2">
                                     <input class="mr-2" formControlName="emailAlert" name="emailalert" type="checkbox" id="emailAlert">
                                     <label class="mb-0" for="emailAlert">
                                         <strong>Yes</strong> - send an email copy of this update to all registered clients.
                                     </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-faded p-3">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-flex align-items-center">
                                <input class="mr-2" formControlName="publishCheck" name="publishCheck" type="checkbox" id="publishCheck">
                                <label class="mb-0" for="publishCheck">
                                    <strong>Are you sure you want to publish these changes?</strong>
                                </label>
                            </div>
                            <button type="submit" class="btn btn-primary btn-sm ml-3" form="latest-update-form" [disabled]="isPublishDisabled">
                                    Publish changes <i class="fa fa-check ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
 </form>